/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/no-unknown-property */
import { Edges, MeshReflectorMaterial, TransformControls } from '@react-three/drei';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Euler, Vector3 } from 'three';

import { StateNames, States } from '../../Screens/Configurator';

type SoleProps = {
  customSole: {
    id: string;
    key: string;
    shape: any;
    shapeDetails: any;
    position: Vector3;
    texture: THREE.Texture;
    isBlocked: boolean;
    extrudeSettings: any;
  };
  orbitRef: React.MutableRefObject<any>;
  pieceIndex: number;
  setPieceIndex: (pieceIndex: number) => void;
  index: number;
  setCustomSoles: (customSoles: any[]) => void;
  customSoles: any[];
  getValue: (stateName: StateNames) => States[StateNames];
  step: string;
};

export const Sole = ({
  customSole,
  orbitRef,
  pieceIndex,
  setPieceIndex,
  index,
  setCustomSoles,
  customSoles,
  getValue,
  step,
}: SoleProps) => {
  const transformRef = useRef<any>();
  const meshRef = useRef<any>();

  useEffect(() => {
    if (transformRef.current) {
      if (meshRef.current) transformRef.current.attach(meshRef.current);
      const controls = transformRef.current;
      const callback = (event: any) => {
        orbitRef.current.enabled = !event.value;
      };
      controls.addEventListener('dragging-changed', callback);
      return () => controls.removeEventListener('dragging-changed', callback);
    }
  });

  const handleChangePiecePosition = useCallback(() => {
    if (index === pieceIndex) {
      const deltaPosition = new Vector3(
        (meshRef?.current?.position.x ?? 0) - customSole.position.x,
        (meshRef?.current?.position.y ?? 0) - customSole.position.y,
        (meshRef?.current?.position.z ?? 0) - customSole.position.z,
      );

      const customsMeshTmp = customSoles.map((mesh) => {
        const newPosition = new Vector3(
          +mesh.position.x + deltaPosition.x,
          +mesh.position.y + deltaPosition.y,
          +mesh.position.z + deltaPosition.z,
        );

        return {
          ...mesh,
          position: newPosition,
        };
      });

      setCustomSoles(customsMeshTmp);
    }
  }, [
    index,
    pieceIndex,
    customSole.position.x,
    customSole.position.y,
    customSole.position.z,
    customSoles,
    setCustomSoles,
  ]);

  return (
    <TransformControls
      ref={transformRef}
      mode="translate"
      size={index === pieceIndex && !customSole.isBlocked ? 1 : 0}
      onMouseUp={() => handleChangePiecePosition()}
    >
      <mesh
        ref={meshRef}
        position={customSole.position}
        rotation={new Euler(0, customSole.shapeDetails.isRotated ? 1.57 : 0, 0, 'XYZ')}
        onClick={(e) => {
          if (e.intersections && e.intersections[0].distance === e.distance) {
            setPieceIndex(pieceIndex);
          }
        }}
      >
        <extrudeGeometry attach="geometry" args={[customSole.shape, customSole.extrudeSettings]} />
        {getValue('texture') ? (
          <meshStandardMaterial map={customSole.texture} metalness={0.95} roughness={0.15} />
        ) : (
          <>
            <Edges />
            <meshStandardMaterial />
          </>
        )}
        {index === pieceIndex &&
        (step === 'CUSTOMIZATION' || step === 'ACCESSORIES' || step === 'PATTERNS') ? (
          <Edges color="red" threshold={10} />
        ) : null}
      </mesh>
    </TransformControls>
  );
};
